import React from "react";
import { ViewMoreUsersInfo } from "../../../pages";

const ViewMoreUsersInfoContainer = ({ closeModal, item }) => {
  return <ViewMoreUsersInfo closeModal={closeModal} item={item} />;
};

export default ViewMoreUsersInfoContainer;
